import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { calculateCpsCplEnglish, calculateCpsCplLanguage, generateClassNames } from './CpsCplHighlighting';
import SubtitleTimeField from './SubtitleTimeField';

const SubtitleTimeSection = ({
    rowData,
    index,
    currentIndex,
    viewEng,
    checkSub,
    handleKeyDown,
    updateSub,
    startField,
    endField,
    startValue,
    endValue,
    disabled = false,
}) => {
    let cpsCplValue;

    if (startField === 'Estart' || endField === 'Eend') {
        cpsCplValue = calculateCpsCplEnglish(rowData, viewEng);
    } else {
        cpsCplValue = calculateCpsCplLanguage(rowData, viewEng);
    }

    return (
        <div
            className={generateClassNames({ rowData, index }, currentIndex, viewEng, checkSub)}
            style={{
                width: '150px',
                textAlign: 'center',
                paddingTop: '5px',
                fontSize: '12px',
            }}
        >
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <SubtitleTimeField
                    value={startValue}
                    onKeyDown={handleKeyDown}
                    field={startField}
                    index={index}
                    updateSub={updateSub}
                    rowData={rowData}
                    disabled={disabled}
                />
                <span
                    className="content"
                    style={{
                        color: disabled ? '#bbb' : 'inherit',
                        opacity: disabled ? 0.5 : 1,
                    }}
                >
                    -
                </span>
                <SubtitleTimeField
                    value={endValue}
                    onKeyDown={handleKeyDown}
                    field={endField}
                    index={index}
                    updateSub={updateSub}
                    rowData={rowData}
                    disabled={disabled}
                />
                <span
                    className="content ss"
                    style={{
                        color: disabled ? '#bbb' : 'inherit',
                        opacity: disabled ? 0.5 : 1,
                    }}
                >
                    seconds
                </span>
                <span
                    className="cps_cpl"
                    style={{
                        color: disabled ? '#bbb' : 'inherit',
                        opacity: disabled ? 0.5 : 1,
                    }}
                >
                    {cpsCplValue}
                </span>
            </LocalizationProvider>
        </div>
    );
};

export default SubtitleTimeSection;
